export const MODALS = {
  M_LANGUAGES_CURRENCY: 'LANGUAGES_CURRENCY'
};

export const SECTIONS = {
  S_LANGUAGES: 'LANGUAGES',
  S_CURRENCY: 'CURRENCY',
};

export const selectUser = (state) => ({
  isAuth: state.user.isAuth,
  currency: state.user.currency,
  language: state.user.language,
  dataPeople: state.user.dataPeople,
});